export default "__VITE_ASSET__BzrNQT5g__"